export default __webpack_public_path__ + "static/media/guidelines-6.c2386f0c.jpeg";